import Vue from 'vue'

Vue.mixin({
  methods: {
    tap () {
      return
    },
    scrollToTop () {
      TweenLite.to(window, .8, {
        scrollTo: {
          y: 0, autoKill: false
        }
      })
    },
    getImage (directory, name, sp) {
      let state = this.$store.state

      let paths = {
        url: state.baseUrl,
        imgDir: '/static/img',
        sp: (typeof sp === 'undefined') ? state.getSpDir : '',
      }

      let base = [
        paths.url, paths.imgDir
      ].join('')

      let path = base + directory + paths.sp + name
      return path
    },
    scrollToTargetSection (hash) {
      if (this.$store.state.isLoading) return false
      this.$nextTick(() => {
        let target = this.$el.querySelector(hash)
        let rect = target.getBoundingClientRect()

        let header = document.querySelector('.p_h-l')
        let headerH = header.clientHeight

        let position = (rect.top + window.pageYOffset) - headerH

        TweenLite.to(window, .8, {
          scrollTo: {
            y: position - headerH + 20, autoKill: false
          }
        })
      })
    },
    closeTheModal () {
      document.querySelector('html').classList.remove('overflow')
      this.$store.commit('MODAL_SHOW', false)
      this.$router.push({query: null})
    },
  }
})



// WEBPACK FOOTER //
// ./src/plugins/mixins.js